

















import { Component, Prop, Vue } from 'vue-property-decorator';
import MapLogLine from '@/components/parts/MapLogLine.vue';
import KmyLogTagText from '@/components/parts/KmyLogTagText.vue';
import * as api from '@/api/api';

@Component({
  components: {
    MapLogLine,
    KmyLogTagText,
  },
})
export default class MapLogList extends Vue {
  @Prop() private logs!: api.MapLog[];
  @Prop() private type!: string;
  @Prop({
    default: false,
  }) private isShowBattleLog!: boolean;
}
